import styled, { css } from 'styled-components';
import Link from 'next/link';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    width: 100%;
    height: 100vh;
    background: ${theme.store.background.blueDark};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    min-height: 800px;
  `}
`;

export const Content = styled.div`
  width: 100%;
  max-width: 400px;
`;

export const NextLink = styled(Link)`
  ${({ theme }) => css`
    color: ${theme.store.brand[500]};
    font-size: 14px;
    font-weight: 400;
    transition: 0.4s;
  `}
`;

export const ErrorInput = styled.div`
  font-size: 12px;
  color: #d82259;
  margin-top: 5px;

  svg {
    width: 0.9rem !important;
    height: 0.9rem !important;
    margin-bottom: -2px;
  }
`;

export const AreaIcon = styled.span`
  svg {
    width: 1.2rem !important;
    height: 1.2rem !important;
    margin-bottom: -5px;
  }
`;

type CellphoneProps = {
  error?: boolean;
};

export const BoxCellphone = styled.div<CellphoneProps>`
  ${({ error }) => css`
    .custom-phone-container {
      box-shadow: none;
      border: ${error ? '2px solid #FC2F59' : '1px solid #e6e8eb'};
      border-radius: 4px;
    }

    .custom-phone-input {
      width: 100%;
      background: #f7f8ff;
      height: 50px;
      border: none;
    }

    .custom-phone-button {
      background-color: #f7f8ff;
      border: none;
      margin-left: 8px;
    }
  `}
`;
